import { NgModule } from '@angular/core';

import { GlobalVarsService } from './global-vars.service';

@NgModule({
  providers: [
    GlobalVarsService
  ]
})
export class GlobalVarsServiceModule { }